// import { MaterialReactTable } from "material-react-table";

// export default function CurrencyTable({
//   data,
//   loading,
//   onEdit,
//   onDelete,
// }) {
//   const columns = [
//     {
//       accessorKey: "code",
//       header: "Code",
//     },
//     {
//       accessorKey: "symbol",
//       header: "Symbol",
//     },
//     {
//       accessorKey: "title",
//       header: "Title",
//     },
//     {
//       accessorKey: "status",
//       header: "Status",
//       Cell: ({ cell }) => (
//         <span
//           className={`rounded px-2 py-1 text-xs ${
//             cell.getValue() === "active"
//               ? "bg-green-100 text-green-700"
//               : "bg-red-100 text-red-700"
//           }`}
//         >
//           {cell.getValue()}
//         </span>
//       ),
//     },
//     {
//       header: "Actions",
//       Cell: ({ row }) => (
//         <div className="flex gap-2">
//           <button
//             onClick={() => onEdit(row.original)}
//             className="rounded bg-yellow-100 px-3 py-1 text-xs"
//           >
//             Edit
//           </button>
//           <button
//             onClick={() => {
//               if (
//                 window.confirm(
//                   `Delete currency "${row.original.code}"?`
//                 )
//               ) {
//                 onDelete(row.original);
//               }
//             }}
//             className="rounded bg-red-100 px-3 py-1 text-xs"
//           >
//             Delete
//           </button>
//         </div>
//       ),
//     },
//   ];

//   return (
//     <MaterialReactTable
//       columns={columns}
//       data={data}
//       state={{ isLoading: loading }}
//       enableSorting={false}
//       enableColumnFilters={false}
//       enableGlobalFilter={false}
//       muiTableBodyRowProps={{ hover: true }}
//     />
//   );
// }
import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import { MdMoreVert, MdEdit, MdDelete } from "react-icons/md";

function CurrencyRow({
  item,
  onEdit,
  onAskDelete,
  openDropdownId,
  setOpenDropdownId,
  openUpward,
  setOpenUpward,
  dropdownRef,
}) {
  const isMenuOpen = openDropdownId === item._id;
  const isActive =
    item.status?.toLowerCase() === "active" || item.status === true;

  const handleToggleMenu = (e) => {
    e.stopPropagation();
    if (isMenuOpen) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(item._id);
    }
  };

  return (
    <tr className="custom-table-row">
      {/* Code */}
      <td className="custom-table-cell font-medium text-gray-800">
        {item.code || "N/A"}
      </td>

      {/* Symbol */}
      <td className="custom-table-cell font-medium text-gray-800">
        {item.symbol || "—"}
      </td>

      {/* Title */}
      <td className="custom-table-cell font-medium text-gray-800">
        {item.title || "N/A"}
      </td>

      {/* Status Badge */}
      <td className="custom-table-cell text-center">
        <span
          className={`inline-block rounded-[8px] px-3 py-1 text-xs font-semibold ${
            isActive
              ? "bg-[#dcfce7] text-[#16a34a]"
              : "bg-[#f1f5f9] text-[#64748b]"
          }`}
        >
          {isActive ? "Active" : "Inactive"}
        </span>
      </td>

      {/* Action Dropdown Menu Cell */}
      <td className="custom-table-cell relative text-center">
        <button onClick={handleToggleMenu} className="action-menu-btn">
          <MdMoreVert className="text-lg" />
        </button>

        {isMenuOpen && (
          <div
            ref={dropdownRef}
            className={`action-dropdown-menu ${
              openUpward ? "menu-bottom" : "menu-top"
            }`}
          >
            <button
              onClick={() => {
                onEdit(item);
                setOpenDropdownId(null);
              }}
              className="action-dropdown-item"
            >
              <MdEdit className="text-base" />
              Edit
            </button>

            <div className="action-dropdown-divider" />

            <button
              onClick={() => {
                onAskDelete(item);
                setOpenDropdownId(null);
              }}
              className="action-dropdown-item"
            >
              <MdDelete className="text-base" />
              Delete
            </button>
          </div>
        )}
      </td>
    </tr>
  );
}

export default function CurrencyTable({ data = [], onEdit, onDelete }) {
  const [deleteRow, setDeleteRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteRow);
      setDeleteRow(null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header">
            <tr>
              <th>Code</th>
              <th>Symbol</th>
              <th>Title</th>
              <th className="text-center">Status</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="5"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No currencies found
                </td>
              </tr>
            ) : (
              data.map((item) => (
                <CurrencyRow
                  key={item._id}
                  item={item}
                  onEdit={onEdit}
                  onAskDelete={setDeleteRow}
                  openDropdownId={openDropdownId}
                  setOpenDropdownId={setOpenDropdownId}
                  openUpward={openUpward}
                  setOpenUpward={setOpenUpward}
                  dropdownRef={dropdownRef}
                />
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Confirmation Modal */}
      <ConfirmModal
        open={Boolean(deleteRow)}
        title="Delete Currency"
        message={`Are you sure you want to delete currency "${
          deleteRow?.code || deleteRow?.title
        }"? This action cannot be undone.`}
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteRow(null)}
      />
    </>
  );
}